var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.computedClass,attrs:{"title":_vm.tooltip},on:{"click":_vm.handleClick}},[_vm._t("default",[_vm._v(_vm._s(_vm.displayText))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }